/* Datenrechner für /pages/data-calculator.
   Lag zuvor als Inline-Skript in der Section und wurde vom Browser nie ausgeführt — das Theme
   setzt #MainContent nach dem Parsen neu ein, und per innerHTML eingefügte Inline-Skripte
   laufen laut HTML-Spezifikation nicht. Als externes, verzögertes Skript ist das kein Problem.
   Die Initialisierung ist idempotent: Sie bricht ab, wenn der Rechner schon aufgebaut ist. */
(function () {
  function aufbauen() {
    var wurzel = document.getElementById('aeroCalc');
    if (!wurzel) return;                      // Rechner nicht auf dieser Seite
    if (wurzel.dataset.asBereit === '1') return;   // schon aufgebaut
    var cats = document.getElementById('acCats');
    if (!cats) return;
    wurzel.dataset.asBereit = '1';
    
    (function(){
      var CATS=[
        {id:'social',label:'Social Media',    apps:'Instagram, TikTok, X, WhatsApp', mb:150,icon:'📱',color:'#00C8E0',def:2,max:8},
        {id:'stream',label:'Video Streaming', apps:'YouTube, Netflix, Disney+',       mb:700,icon:'🎬',color:'#4B7BE8',def:1,max:6},
        {id:'calls', label:'Video Calls',     apps:'Zoom, FaceTime, Google Meet',     mb:500,icon:'📹',color:'#7C3AED',def:0,max:6},
        {id:'maps',  label:'Navigation',      apps:'Google Maps, Waze, Uber',         mb:50, icon:'🗺',color:'#10B981',def:1,max:6},
        {id:'music', label:'Music & Podcasts',apps:'Spotify, Apple Music, Podcasts',  mb:60, icon:'🎵',color:'#F59E0B',def:2,max:8},
        {id:'msg',   label:'Messaging',       apps:'WhatsApp, Telegram, Gmail',       mb:20, icon:'💬',color:'#EC4899',def:3,max:8}
      ];
      var PLAN_DAYS=[1,3,5,7,10,14,20,30];
      var hrs={};
      CATS.forEach(function(c){hrs[c.id]=c.def;});
      var tripDays=7;
    
      function bestPlan(d){for(var i=0;i<PLAN_DAYS.length;i++){if(d<=PLAN_DAYS[i])return PLAN_DAYS[i];}return 30;}
      function fmtH(h){if(h===0)return'Off';if(h===0.5)return'30 min';if(h===1)return'1 hour';return h+' hrs';}
      function sliderBg(el,color){
        var pct=((parseFloat(el.value)-parseFloat(el.min))/(parseFloat(el.max)-parseFloat(el.min)))*100;
        el.style.background='linear-gradient(to right,'+color+' '+pct+'%,rgba(255,255,255,0.08) '+pct+'%)';
      }
      function animNum(el,target,dec){
        // Endwert zuerst schreiben: Er bleibt stehen, wenn requestAnimationFrame nicht feuert
        // (inaktiver Tab, Hintergrundfenster). Die Animation laeuft nur darueber und wird
        // NICHT synchron gestartet — sonst ueberschriebe ihr erster Schritt den Endwert
        // sofort wieder mit dem Startwert.
        var s=parseFloat(el.textContent)||0,t0=performance.now(),dur=380;
        el.textContent=target.toFixed(dec);
        if(typeof requestAnimationFrame!=='function')return;
        requestAnimationFrame(function step(now){
          var p=Math.min((now-t0)/dur,1),e=1-Math.pow(1-p,3);
          el.textContent=(s+(target-s)*e).toFixed(dec);
          if(p<1)requestAnimationFrame(step);
        });
      }
      function update(){
        var mb=0;
        CATS.forEach(function(c){mb+=hrs[c.id]*c.mb;});
        var daily=mb/1024,total=daily*tripDays;
        animNum(document.getElementById('acDaily'),daily,1);
        animNum(document.getElementById('acTotal'),total,1);
        var bar=document.getElementById('acBar');
        bar.innerHTML='';
        CATS.forEach(function(c){
          var seg=document.createElement('div');
          seg.className='ac__bar-seg';
          seg.style.width=(mb>0?(hrs[c.id]*c.mb/mb*100):0)+'%';
          seg.style.background=c.color;
          bar.appendChild(seg);
        });
        var plan=bestPlan(tripDays);
        document.getElementById('acPlanName').textContent=plan+'-Day Unlimited eSIM';
        document.getElementById('acCtaDays').textContent=plan;
        document.getElementById('acTripDays').textContent=tripDays;
      }
      function buildCats(){
        var wrap=document.getElementById('acCats');
        CATS.forEach(function(c){
          var div=document.createElement('div');
          div.className='ac__cat';
          div.innerHTML='<div class="ac__cat-icon" style="background:'+c.color+'18;">'+c.icon+'</div>'+
            '<div><div class="ac__cat-name">'+c.label+'</div><div class="ac__cat-apps">'+c.apps+'</div></div>'+
            '<div class="ac__cat-ctrl"><div class="ac__cat-val" id="v_'+c.id+'" style="color:'+c.color+'">'+fmtH(c.def)+'</div>'+
            '<input type="range" class="ac__range" id="s_'+c.id+'" min="0" max="'+c.max+'" step="0.5" value="'+c.def+'"></div>';
          wrap.appendChild(div);
          var sl=document.getElementById('s_'+c.id);
          sliderBg(sl,c.color);
          sl.addEventListener('input',function(){
            hrs[c.id]=parseFloat(this.value);
            document.getElementById('v_'+c.id).textContent=fmtH(hrs[c.id]);
            sliderBg(this,c.color);update();
          });
        });
        var leg=document.getElementById('acLegend');
        CATS.forEach(function(c){
          var li=document.createElement('div');
          li.className='ac__legend-item';
          li.innerHTML='<div class="ac__legend-dot" style="background:'+c.color+'"></div>'+c.label;
          leg.appendChild(li);
        });
      }
      var ts=document.getElementById('acTripSlider');
      sliderBg(ts,'#00C8E0');
      ts.addEventListener('input',function(){tripDays=parseInt(this.value);sliderBg(this,'#00C8E0');update();});
      document.getElementById('acReset').addEventListener('click',function(){
        CATS.forEach(function(c){
          hrs[c.id]=c.def;
          var s=document.getElementById('s_'+c.id);if(s){s.value=c.def;sliderBg(s,c.color);}
          var v=document.getElementById('v_'+c.id);if(v)v.textContent=fmtH(c.def);
        });
        tripDays=7;ts.value=7;sliderBg(ts,'#00C8E0');update();
      });
      buildCats();update();
    })();
    
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aufbauen);
  else aufbauen();
  // Theme-Editor und dynamisch nachgeladene Bereiche
  document.addEventListener('shopify:section:load', aufbauen);
  // Letzte Absicherung: falls das Theme den Bereich später ersetzt
  window.addEventListener('pageshow', aufbauen);
})();
